<template>
    <div>
        <div class="container" v-if="list.length">
            <div class="data_ctrl">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <el-button v-if="['stay', 'pass'].includes(page)" class="ml" type="primary" size="small" @click="handleCtrlExecute(2)">拒绝</el-button>
                <el-button v-if="['stay', 'reject'].includes(page)" class="ml" type="primary" size="small" @click="handleCtrlExecute(1)">通过</el-button>
                
                <span class="preview_num" v-if="checked.length">已选择<em>{{checked.length}}</em>个</span>
            </div>
            
            <div class="data_list" v-loading="loading">
                <div
                    class="item"
                    v-for="(item, i) in list"
                    :key="i"
                >
                    <div class="resource" @click="handleSelectResource(item)">
                        <div class="checkbox" :class="{ 'on': checked.findIndex(v => v.audit_id === item.audit_id) >= 0 }"></div>
                        <div class="poster" :class="{ 'img_group': item.material_previewer.length > 1}">
                            <template v-if="item.material_previewer && item.material_previewer.length && item.material_previewer[0].indexOf('mp4') >= 0">
                                <div class="ico_video" @click.stop="handleOpenDetail(item)">
                                    <svg t="1713855455572" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6925" width="40" height="40"><path d="M416 704c-6.4 0-9.6 0-16-3.2C390.4 694.4 384 684.8 384 672L384 352c0-12.8 6.4-22.4 16-28.8 9.6-6.4 22.4-6.4 32 0l256 166.4c9.6 6.4 16 16 16 28.8 0 9.6-6.4 22.4-16 25.6l-256 156.8C428.8 704 422.4 704 416 704zM448 409.6l0 204.8 163.2-99.2L448 409.6z" p-id="6926" fill="#e6e6e6"></path><path d="M512 960C265.6 960 64 758.4 64 512S265.6 64 512 64s448 201.6 448 448S758.4 960 512 960zM512 128C300.8 128 128 300.8 128 512c0 211.2 172.8 384 384 384 211.2 0 384-172.8 384-384C896 300.8 723.2 128 512 128z" p-id="6927" fill="#e6e6e6"></path></svg>
                                </div>
                                <video :src="item.material_previewer[0]" :poster="item.material_poster"></video>
                            </template>
                            <template v-else>
                                <img
                                    v-for="(cItem, cIndex) in item.material_previewer"
                                    :key="cIndex"
                                    :src="cItem"
                                    :alt="item.material_title"
                                >
                            </template>
                        </div>
                        <div class="btns">
                            <a href="javascript:;" v-if="['stay'].includes(page)" @click.stop="handleCtrlExecuteSingle(item, 1)">审核通过</a>
                            <a href="javascript:;" @click.stop="handleOpenDetail(item)">查看详情</a>
                            <a href="javascript:;" v-if="['stay'].includes(page)" @click.stop="handleCtrlExecuteSingle(item, 2)">审核拒绝</a>
                        </div>
                    </div>
                    <div class="title">{{ item.material_title }}</div>
                    <div class="title">
                        <a :href="item.click_link" target="_blank">{{ item.click_link }}</a>
                    </div>
                </div>
            </div>
    
            <!-- <div class="page_preview">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="pageNum"
                    :page-size="pageSize"
                    :total="total"
                    @current-change="handleChangePage"
                ></el-pagination>
            </div> -->

            <div class="page_preview">
                <div class="pagination_ctl" id="pagination_ctl">
                    <!-- 上一页 -->
                    <el-button
                    v-if="showPrev"
                    type="text"
                    @click="goPrev"
                    style="margin-right: 12px"
                    >上一页</el-button>

                    <!-- 页码跳转 -->
                    <el-select
                    :value="currentPage"
                    placeholder="跳转至"
                    style="width: 120px"
                    @change="goJump"
                    >
                    <el-option
                        v-for="opt in pageOptions"
                        :key="opt.value"
                        :label="opt.label"
                        :value="opt.value"
                    />
                    </el-select>

                    <!-- 每页条数 -->
                    <el-select
                    :value="pageSize"
                    :placeholder="`${pageSize}条 / 页`"
                    style="width: 120px; margin-left: 24px"
                    @change="changePageSize"
                    >
                    <el-option
                        v-for="opt in pageSizeOptions"
                        :key="opt.value"
                        :label="opt.label"
                        :value="opt.value"
                    />
                    </el-select>

                    <!-- 下一页 -->
                    <el-button
                    v-if="hasMore"
                    type="text"
                    @click="goNext"
                    style="margin-left: 12px"
                    >下一页</el-button>
                </div>
            </div>
        </div>
    
        <el-empty v-if="!list.length" description="暂无数据" v-loading="loading"></el-empty>
    
        <!-- preview -->
        <el-dialog
            title="素材详情"
            width="60%"
            :visible.sync="dialogVisible"
            @close="handleOpenDetailClose"
        >
            <div class="preview">
                <div class="resource">
                    <div class="poster" :class="{ 'img_group': dialog.material_previewer && dialog.material_previewer.length > 1}">
                        <template v-if="dialog.material_previewer && dialog.material_previewer.length && dialog.material_previewer[0].indexOf('mp4') >= 0">
                            <video :src="dialog.material_previewer[0]" :poster="dialog.material_poster" autoplay controls ref="preview_video"></video>
                        </template>
                        <template v-else>
                            <img
                                v-for="(cItem, cIndex) in dialog.material_previewer"
                                :key="cIndex"
                                :src="cItem"
                                :alt="dialog.material_title"
                            >
                        </template>
                    </div>
                </div>
                <div class="text">
                    <span class="label">审核ID:</span>
                    <span class="cont">{{ dialog.audit_id }}</span>
                </div>
                <div class="text">
                    <span class="label">产品名称:</span>
                    <span class="cont">{{ dialog.product_name }}</span>
                </div>
                <div class="text">
                    <span class="label">操作系统:</span>
                    <span class="cont">{{ dialog.os | formatOs }}</span>
                </div>
                <div class="text">
                    <span class="label">素材标题:</span>
                    <span class="cont">{{ dialog.material_title }}</span>
                </div>
                <div class="text">
                    <span class="label">点击链接:</span>
                    <span class="cont">
                        <a :href="dialog.click_link" target="_blank">{{ dialog.click_link }}</a>
                    </span>
                </div>
                <div class="text">
                    <span class="label">Deeplink:</span>
                    <span class="cont">{{ dialog.deep_link }}</span>
                </div>
                <div class="btns">
                    <el-button v-if="['stay', 'reject'].includes(page)" type="primary" @click="handleCtrlExecuteSingle(dialog, 1)">审核通过</el-button>
                    <el-button v-if="['stay', 'pass'].includes(page)" @click="handleCtrlExecuteSingle(dialog, 2)">审核拒绝</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getPreviewIdeaPendingList, getPreviewIdeaReviewedList, setPreviewCollectionAudit } from '@/apis/advCenter.js';

export default {
    name: 'audit-list',
    data() {
        return {
            isIndeterminate: false,
            checkAll: false,
            checked: [],
    
            loading: false,
            pageNum: 1,
            // pageSize: 100,
            list: [],
            total: 0,
    
            dialogVisible: false,
            dialog: {},
            
            // 已累积的游标数组 (按获取顺序)
            cursors: [],
            // 当前生效的游标；'' 代表第 1 页
            currentCursor: '',
            // 当前页码 (1-based)
            currentPage: 1,
            // 每页条数
            pageSize: 20,
            // 是否还有下一页 (接口返回 next_cursor 非空即为 true)
            hasMore: false,
            pageSizeOptions: [
                { value: 10, label: '10条 / 页' },
                { value: 20, label: '20条 / 页' },
                { value: 50, label: '50条 / 页' },
                { value: 100, label: '100条 / 页' },
            ]
        }
    },
    
    props: {
        page: String,
        search: Object,
        collectionId: [Number, String],
        reload: Boolean
    },

    computed: {
        // 上一页可见条件：存在游标且当前不在第 1 页
        showPrev() {
            return this.cursors.length > 0 && this.currentCursor !== ''
        },
        // 页码下拉选项：第1页 + cursors 对应的第2..N页
        pageOptions() {
            const opts = [{ value: 1, label: '第1页' }]
            this.cursors.forEach((_, index) => {
                opts.push({ value: index + 2, label: `第${index + 2}页` })
            })
            return opts
        },
    },
    
    watch: {
        reload(oldVal, newVal) {
            console.log('list watch reload >>> ', oldVal, newVal);
            if (oldVal) {
                this.reset();
                this.getListNew();
                this.$emit('update:reload', false);
            }
        },
        search(oldVal, newVal) {
            console.log('list watch search >>> ', oldVal, newVal);
            this.reset();
            this.getListNew();
        },
        collectionId(oldVal, newVal) {
            console.log('ist watch collectionId >>> ', oldVal, newVal);
            this.reset();
            this.getListNew();
        }
    },
  
    filters: {
        formatOs(v) {
            let map = {
                0: '通投',
                2: 'Android',
                5: 'iOS'
            }
            return map[v];
        }
    },
    
    methods: {
        init() {
        },

        // 上一页：在 cursors 中定位当前游标，取前一个；若已到最前则游标为 '' (第1页)
        goPrev() {
            let _cursor = ''
            const _index = this.cursors.findIndex((item) => item === this.currentCursor)
            if (_index > -1 && _index > 0) {
                _cursor = this.cursors[_index - 1]
            }
            const _page = _cursor ? (this.currentPage || 0) - 1 : 1

            this.currentCursor = _cursor
            this.currentPage = _page

            this.getListNew({ cursor: _cursor })
            this.$emit('callback', { scrollTop: true })
        },
        // 下一页：当前为第1页('')时取 cursors[0]；否则取下一个游标
        goNext() {
            let _cursor = ''
            if (this.currentCursor === '') {
                _cursor = this.cursors[0] || ''
            } else {
                const _index = this.cursors.findIndex((item) => item === this.currentCursor)
                if (_index > -1 && _index < this.cursors.length - 1) {
                _cursor = this.cursors[_index + 1]
                }
            }
            const _page = (this.currentPage || 0) + 1

            this.currentCursor = _cursor
            this.currentPage = _page

            this.getListNew({ cursor: _cursor })
        },
        // 跳页：第 p 页 → cursor = cursors[p-2] (第1页为 '')
        goJump(val) {
            const _cursor = this.cursors[val - 2] || ''

            this.currentPage = val;
            this.currentCursor = _cursor

            this.getListNew({ cursor: _cursor })
            this.$emit('callback', { scrollTop: true })
        },
        // 改变每页条数：重置到第 1 页并清空游标
        changePageSize(val) {
            this.currentPage = 1
            this.cursors = []
            this.currentCursor = ''
            this.pageSize = val

            this.getListNew({ cursor: '' })
            this.$emit('callback', { scrollTop: true })
        },
        
        reset() {
            this.pageNum = 1;
            this.list = [];
            this.isIndeterminate = false;
            this.checkAll = false;
            this.checked = [];

            // 重置游标
            this.currentPage = 1
            this.cursors = []
            this.currentCursor = ''
        },

        async getList() {
            if (!this.collectionId) return;
            this.loading = true;
            
            let params = {
                page: this.pageNum,
                page_size: this.pageSize,
                collection_id: this.collectionId
            }
            
            if (this.page === 'stay') params['review_type'] = 0;
            if (this.page === 'pass') params['review_type'] = 1;
            if (this.page === 'reject') params['review_type'] = 2;
            if (this.search.date && this.search.date.length) params['audit_time'] = this.search.date[0] + '~' + this.search.date[1];
            if (this.search.keyword) params['idea_title'] = this.search.keyword;
            if (this.search.adSlotId) params['adslot_id'] = this.search.adSlotId;
            if (this.search.materialType) params['acc_adtype'] = this.search.materialType;
            if (this.search.os || this.search.os === 0) params['os'] = this.search.os;
            
            let res = null;
            if (['pass', 'reject'].includes(this.page)) {
                res = await getPreviewIdeaReviewedList(params);
            } else {
                res = await getPreviewIdeaPendingList(params);
            }
            if (res.code && res.code === 200) {
                this.list = res.data.list;
                this.total = res.data.total;
            }
            this.loading = false;
        },

        async getListNew(data) {
            const { cursor } = data || {};
            if (!this.collectionId) return;
            this.loading = true;
            
            let params = {
                page: this.pageNum,
                page_size: this.pageSize,
                collection_id: this.collectionId,
                cursor: cursor || '',
            }
            
            if (this.page === 'stay') params['review_type'] = 0;
            if (this.page === 'pass') params['review_type'] = 1;
            if (this.page === 'reject') params['review_type'] = 2;
            if (this.search.date && this.search.date.length) params['audit_time'] = this.search.date[0] + '~' + this.search.date[1];
            if (this.search.keyword) params['idea_title'] = this.search.keyword;
            if (this.search.adSlotId) params['adslot_id'] = this.search.adSlotId;
            if (this.search.materialType) params['acc_adtype'] = this.search.materialType;
            if (this.search.os || this.search.os === 0) params['os'] = this.search.os;
            
            let res = null;
            if (['pass', 'reject'].includes(this.page)) {
                res = await getPreviewIdeaReviewedList(params);
            } else {
                res = await getPreviewIdeaPendingList(params);
            }
            if (res.code && res.code === 200) {
                this.list = res.data.list;
                this.total = res.data.total;

                let _cursor = res.data.next_cursor || '';

                this.hasMore = !!_cursor;

                if (this.cursors.length === 0) {
                    this.cursors = [_cursor]
                } else {
                    this.cursors[this.currentPage - 1] = _cursor
                }
            }
            this.loading = false;
        },
        
        // 单选
        handleSelectResource(item) {
            let findIndex = this.checked.findIndex(v => {
                return v.audit_id === item.audit_id;
            });
            if (findIndex >= 0) {
                this.checked.splice(findIndex, 1);
            } else {
                this.checked.push(item);
            }
    
            let checkedCount = this.checked.length;
            this.checkAll = checkedCount === this.list.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
        },
    
        // 全选
        handleCheckAllChange(val) {
            this.checked = val ? [...this.list] : [];
            this.isIndeterminate = false;
        },
        
        // // 切换分页
        // handleChangePage(n) {
        //     this.isIndeterminate = false;
        //     this.checkAll = false;
        //     this.checked = [];
        //     this.pageNum = n;
        //     this.getList();
        //     this.$emit('callback', { scrollTop: true })
        // },
        
        // 操作(拒绝&通过) - 单点
        handleCtrlExecuteSingle(obj, audit) {
            this.checked = [obj];
            this.handleCtrlExecute(audit);
        },
        
        // 操作(拒绝&通过) - 批量
        async handleCtrlExecute(audit) {
            let ids = [];
            let version = {}
            this.checked.forEach(v => {
                ids.push(v.audit_id);
                version[v.audit_id] = v.version;
            });
            
            if (!ids.length) {
                this.$message.error('请选择素材');
                return;
            }
            
            const {code, message} = await setPreviewCollectionAudit({
                collection_id: this.collectionId,
                audit_ids: ids,
                version: version,
                audit
            });
            if (code && code === 200) {
                this.isIndeterminate = false;
                this.checkAll = false;
                this.checked = [];
                this.$message.success('操作成功');
                this.getListNew( {cursor: this.currentCursor} );
                this.$emit('callback', { listReload: true });
                this.dialogVisible = false;
            } else {
                this.$message.error(message);
            }
        },
        
        // 素材详情
        handleOpenDetail(item) {
            this.dialogVisible = true;
            this.dialog = {...item};
            this.$refs.preview_video && this.$refs.preview_video.play();
        },

        // 素材详情关闭
        handleOpenDetailClose() {
            this.$refs.preview_video && this.$refs.preview_video.pause();
        }
    },
    
    mounted() {
        this.init();
    }
}
</script>

<style lang="scss" scoped>
.container{
    position: sticky;
    top: 0;
    margin-top: 10px;
    & .data_ctrl{
        position: sticky;
        top: 40px;
        z-index: 2;
        padding-top: 5px;
        padding-bottom: 5px;
        background: #fff;
        & .ml{margin-left: 15px;}
        & .preview_num{
            margin-left: 15px;
            font-size: 14px;
            color: #555;
            & em{
                font-style: normal;
                color: #409EFF;
            }
        }
    }
    & .data_list{
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
        & .item{
            margin-right: 2.3%;
            margin-bottom: 30px;
            padding: 12px;
            padding-bottom: 10px;
            width: 20%;
            display: flex;
            flex-direction: column;
            border: 1px solid #eee;
            box-shadow: 1px 3px 5px #eee;
            border-radius: 8px;
            
            & .resource{
                position: relative;
                margin-bottom: 6px;
                width: 100%;
                height: 160px;
                background: #f0f0f0;
                display: flex;
                justify-content: center;
                align-items: center;
                &:hover{
                    & .btns{display: flex;}
                }
                & .checkbox{
                    position: absolute;
                    right: 0px;
                    top: 0px;
                    width: 15px;
                    height: 15px;
                    border: 1px solid #ccc;
                    background: #fff;
                    z-index: 1;
                    &.on{
                        background: #409EFF;
                        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAANZJREFUOE+9k6tOQ0EURdeSfAZ1Tar4ADS6pB5RBRgSBIoWhQIFpqg6FJ7wEQTbaiwWRXZ7SdtcHpdM04Sxc/Y5a+8zIxscN9Dyv+Ik98CberjW5CRjYFvdrewWi5OMgB7QUV9X4iRb6ntTeElugCNgT31c1n1OTvIEtICu+lJvkuQaOAFO1av63Qo7yR3QB47V20XTS+Bs7nOsHnwn++I5yXAOMgCqRCfAOfCs7vxm6UdgtQZV/QfQVqdF4gXukmBffWgKsnFVSQbqxV/Pt3jPxdiln2UGMbpBEKBjAjoAAAAASUVORK5CYII=');
                        background-size: cover;
                    }
                }
                & .poster{
                    position: relative;
                    max-width: 100%;
                    max-height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    &.img_group{
                        & img{width: 33%;}
                    }
                    & .ico_video{
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        width: 40px;
                        height: 40px;
                        cursor: pointer;
                        z-index: 1;
                    }
                    & img, & video {
                        display: block;
                        max-width: 100%;
                        max-height: 160px;
                    }
                }
                & .btns{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 30px;
                    background: rgba(255, 255, 255, 0.7);
                    display: none;
                    justify-content: space-around;
                    align-items: center;
                    & a{
                        display: block;
                        width: 100%;
                        height: 30px;
                        line-height: 30px;
                        color: #409EFF;
                        font-size: 14px;
                        text-align: center;
                        text-decoration: none;
                    }
                }
            }
            & .title{
                height: 25px;
                line-height: 25px;
                font-size: 14px;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                & a{
                    color: #666;
                    text-decoration: none;
                    &:hover{text-decoration: underline;}
                }
            }
        }
    }
    & .page_preview{
        padding-bottom: 20px;
        text-align: right;
    }
}

.preview {
    & .resource {
        position: relative;
        margin-bottom: 10px;
        width: 100%;
        height: 250px;
        background: #caced4;
        display: flex;
        justify-content: center;
        align-items: center;
        & .poster {
            max-width: 100%;
            max-height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            &.img_group{
                & img{width: 33%;}
            }
            & img, & video {
                display: block;
                max-width: 100%;
                max-height: 250px;
            }
            & video{
                min-width: 200px;
                min-height: 250px;
            }
        }
    }
    & .text {
        padding: 3px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        & .label {
            width: 120px;
            text-align: right;
            font-size: 14px;
        }
        & .cont {
            margin-left: 10px;
            max-width: 680px;
            font-size: 14px;
            color: #666;
        }
    }
    & .btns{
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
#pagination_ctl.pagination_ctl {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
